import { isIos, isMobileLandscape, isStandalone } from '../styles/media'

export const getAppMenuHeight = (authToken) => authToken ? (isStandalone() && isIos() ? (isMobileLandscape() ? '78px' : '84px') : '50px') : '0px'
